const PARENT_URL = process.env.REACT_APP_PARENT_URL;

export function postMessageSender(payload, parentOrigin = PARENT_URL) {
  const isInIframe = window.location !== window.parent.location;

  if (isInIframe) {
    const serialized = JSON.stringify(payload);

    window.parent.postMessage(serialized, parentOrigin);
  }
}
